  /* eslint-disable no-script-url */
  /* eslint-disable camelcase */
  import React, { useEffect, useRef, useState } from 'react'
  import './tabs.css'
  import Tooltip from '../tooltip/tooltips'

  const getTabHeightValue = (tabHeight: string | number | undefined) => {
    if (typeof tabHeight === 'number') {
      return `${tabHeight}px`
    }

    return tabHeight
  }

  interface Props {
    pagetitle?: any
    pagetitleClass?: any
    items?: any,
    mainTabsclass?: any,
    tabsul?: any,
    tablistclassName?: any,
    className?: any,
    type?: any,
    anchorclass?: any,
    id?: any,
    isButtons?: any,
    tabscontentarea?: any,
    badge?: any,
    contentstyles?: any,
    isInfo?: any,
    infoClassName?: any,
    info?: any,
    infoIcon?: any,
    isCheckboxAll?:boolean,
    tabHeight?: string | number
    enableHeaderHeight?: boolean
    setActiveTab: (index: number) => void
    statusNotesActive?: boolean
    name?: string
    tabClassName?: any
    pagetitleicon?: any
  }
  export default function Tabs(props: Props) {
    const [items, setItems] = useState(props.items)
    const [bottonhide, setBottonhide] = useState(false)
    const [selectedTab, setSelectedTab] = useState<number | undefined>()
    const tabListClassName = [props?.tabsul, 'customtabs-list', props?.tablistclassName].filter(Boolean).join(' ')
    const tabHeight = getTabHeightValue(props?.tabHeight)
    const tabsStyle = tabHeight
      ? {
          ['--customtabs-tab-height' as string]: tabHeight,
          ['--customtabs-tab-border-top' as string]: `calc(${tabHeight} - 1px)`
        }
      : undefined

    const show = (event: any | null, selectedIndex: number) => {
      event?.preventDefault?.() // Safely call if it exists
      const tabs = [...props.items]
      props.setActiveTab(selectedIndex)
      tabs.map((item: any, index: number) => {
        if ('is_active' in item) {
          item.is_active = false
          if (selectedIndex === index) {
            item.is_active = true
          }
        }
        return item
      })
      setItems([...tabs])
      setSelectedTab(selectedIndex)
      setTimeout(() => {
        const tabList = document.querySelectorAll('[data-tabitem]')
        const currentTab = tabList[selectedIndex] as HTMLElement;
        const container = currentTab?.closest('.customtabs-list') as HTMLElement
        if (currentTab && container) {
        currentTab.focus()

        // Calculate center offset
        const tabRect = currentTab.getBoundingClientRect()
        const containerRect = container.getBoundingClientRect()

        const offset = tabRect.left - containerRect.left - (container.clientWidth / 2) + (currentTab.clientWidth / 2)

        container.scrollTo({
          left: container.scrollLeft + offset,
          behavior: 'smooth'
        })
      }
      }, 0)
    }


  const [tabsHeaderHeight, setTabsHeaderHeight] = useState<number>(0);
    const headerRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
      if (!props.enableHeaderHeight) return;
      const tabsHeader = document.querySelector('[data-tabsheader="true"]') as HTMLElement;
      headerRef.current = tabsHeader;

      if (!tabsHeader) return;

      const resizeObserver = new ResizeObserver(() => {
        const height = tabsHeader.offsetHeight;
        setTabsHeaderHeight(height);
      });

      resizeObserver.observe(tabsHeader);

      // Initial height update
      const initialHeight = tabsHeader.offsetHeight;
      setTabsHeaderHeight(initialHeight);


      return () => {
        resizeObserver.disconnect();
      };
    }, [props?.name, props?.enableHeaderHeight]);

    useEffect(() => {
      document.documentElement.style.setProperty(`--tabsheader-height-${props.id}`, `${tabsHeaderHeight}px`);
    }, [tabsHeaderHeight]);






    useEffect(() => {
      if (props.statusNotesActive) {
        show(null, 1)
      }
    }, [props.statusNotesActive])
    useEffect(() => {
      setItems(props?.items)
    }, [props?.items])
    return (
      <>
        <div className={props?.mainTabsclass ? `tabs ${props?.mainTabsclass}` : 'tabs'} >        
          <div className={props?.className ? `customtabs ${props?.className}` : 'customtabs d-flex flex-row w-100'} style={tabsStyle} >          
            <div className="customtabs-header" data-tabsheader="true">
              {props?.pagetitle && <h2 className={props?.pagetitleClass} tabIndex={0} aria-label={props?.pagetitle}>{props?.pagetitleicon && <span className={props?.pagetitleicon}></span>}{props?.pagetitle}</h2>}
              <ul className={tabListClassName} role="tablist" aria-label="Tabs Navigation">
                {
                  props?.items?.map((item: any, index: number) => {
                    const tabKey = item?.tabId || `${props?.id}-${index}-${String(item?.tabtitle || '')}`
                    return (
                      <li key={tabKey} className={props?.tabClassName} role="presentation">
                        <a data-tabitem tabIndex={0} href="javascript:void(0)" title={item?.title || item?.tabtitle} onClick={(event) => show(event, index)} onKeyDown={(event) => {if(event.key ===" " || event.key === "Enter"){show(event, index)}}} className={item.is_active ? props?.anchorclass ? `active ${props?.anchorclass}` : 'active' : props?.anchorclass ? `${props?.anchorclass}` : ''} aria-selected={item.is_active ? 'true' : 'false'} role='tab'  id={`tab-${props?.id}-${index}`}
    aria-controls={`tabpanel-${props?.id}-${index}`}>
                          {item?.icon && <span className={item?.icon}></span>} {item?.tabtitle} {props?.badge && <span className={props?.badge}>({item?.count})</span>}
                          {item?.info && <Tooltip content={item?.info}>
                            <span className={item.infoClassName ? `icon-rb-info ps-1 ${item?.infoClassName}` : 'icon-rb-info ps-1 color-primary'}></span>
                          </Tooltip>}
                        </a>
                      </li>
                    )
                  })
                }
              </ul>
              {!bottonhide && props?.isButtons}
            </div>
          </div>
          <div className={props?.tabscontentarea} id={props?.id}>
            {
              props?.items?.map((item: any, index: number) => {
                const panelKey = item?.panelId || `tabpanel-${props?.id}-${index}`
                if (!item.is_active) return null
                return (
                  <div key={panelKey} className={`customtabs-content ${item.is_active ? 'active' : ''}`} role="tabpanel"
                    id={`tabpanel-${props?.id}-${index}`}
                    aria-labelledby={`tab-${props?.id}-${index}`}>
                    <div className={props?.contentstyles}>{item?.content}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </>
    )
  }
